<div class="modal fade"
     bsModal #messageBoxModel="bs-modal" 
     [config]="{backdrop: 'static'}" 
     tabindex="-1"
     role="dialog" 
     aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left" 
                    [innerHTML]='modalHeader'>
                </h4>            
                <button type="button" 
                        class="close float-sm-right" 
                        aria-label="Close" 
                        (click)="closeModal(MyModalResult.None)"
                        *ngIf="!hideCloseButton">
                    <span aria-hidden="true">
                        <img src="assets/img/icon-close-reversed.png">
                    </span>
                </button>
            </div>
            <div class="modal-body">
                <div  [innerHTML]='displayText' 
                      *ngIf="displayText"></div>
                <div *ngIf ="itemList.length > 0" >
                    <ul #scrollContainer 
                        class="modal-area-scrollable">
                        <li *ngFor="let item of itemList">
                            {{item}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="modal-footer">
                <div class="col-6 text-align-left" 
                     *ngIf="!hideCancelButton">
                    <button class="btn btn-primary " 
                            (click)="closeModal(MyModalResult.Cancel)">
                        Cancel
                    </button>
                </div>
                <div class="{{hideCancelButton ? 'col-12 text-align-right' : 'col-6 text-align-right'}}" 
                     *ngIf="!hideConfirmButton">
                    <button class="btn btn-primary" 
                            (click)="closeModal(MyModalResult.Ok)">
                        {{buttonText}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>